<template>
    <div class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" :src="backIcon" @click="moving()" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Pengadaan</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.namaPengadaan.$model"
                            :class="{ 'is-invalid':$v.namaPengadaan.$error, 'is-valid': !$v.namaPengadaan.$invalid }"
                            placeholder="Nama Pengadaan"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nomor Pengadaan</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.nomorPengadaan.$model"
                            :class="{ 'is-invalid':$v.nomorPengadaan.$error, 'is-valid': !$v.nomorPengadaan.$invalid }"
                            placeholder="Nomor Pengadaan"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Quantity PO</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.qty.$model"
                            :class="{ 'is-invalid':$v.qty.$error, 'is-valid': !$v.qty.$invalid }"
                            placeholder="Qty PO"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Tanggal Pengadaan</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.tanggalPengadaan.$model"
                            :class="{ 'is-invalid':$v.tanggalPengadaan.$error, 'is-valid': !$v.tanggalPengadaan.$invalid }"
                            type="date"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nama Penyedia Jasa Tenaga Kerja (PJTK)</label>
                        <model-select :options="dataPJTK"
                            class="form-control model-select"
                            v-model.trim="$v.pjtk.$model"
                            :class="{ 'select-invalid':$v.pjtk.$error, 'select-valid': !$v.pjtk.$invalid }"
                            placeholder="Nama PJTK">
                        </model-select>
                    </CCol>
                    <CCol sm="6">
                        <label>Bidang</label>
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    @click="toggleVisibleUnit()"
                                    @blur="toggleCloseVisibleUnit()"
                                    v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                                    v-model="queryUnit"
                                    @keydown.up="upUnit"
                                    @keydown.down="downUnit"
                                    @keydown.enter="selectItemUnit"
                                    placeholder="Pilih Bidang"
                            >
                            <div class="popovers" v-show="visibleUnit">
                                <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesUnit"
                                        :key="index"
                                        :class="{ 'selected': (selectedUnit == index)}"
                                        @click="itemClickedUnit(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                        <div v-if="tempBidang.length != 0" class="mb-4">
                            <CRow v-for="(lvl, id) in tempBidang" :key="id">
                                <CCol sm="11">
                                    -  {{lvl.bidang}}
                                </CCol>
                                <CCol sm="1">
                                    <span @click="deleteUnit(id)" style="cursor:pointer" title="Hapus">x</span>
                                </CCol>
                            </CRow>
                        </div>
                    </CCol>
                </CRow>
                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 mt-0 ml-0 mr-0 mb-4"/>
                <CRow v-if="tempBidang.length != 0 && pjtk.value != '' && (qty != 0 || qty == '')">
                    <CCol sm="6">
                        <label>Pegawai</label>
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    @click="toggleVisiblePegawai()"
                                    @blur="toggleCloseVisiblePegawai()"
                                    v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                    v-model="queryPegawai"
                                    @keydown.up="upPegawai"
                                    @keydown.down="downPegawai"
                                    @keydown.enter="selectItemPegawai"
                                    placeholder="Pilih Pegawai"
                            >
                            <div class="popovers" v-show="visiblePegawai">
                                <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesPegawai"
                                        :key="index"
                                        :class="{ 'selected': (selectedPegawai == index)}"
                                        @click="itemClickedPegawai(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                </CRow>
                <CRow v-if="tempBidang.length != 0 && pjtk.value != '' && (qty != 0 || qty == '')" class="pl-3 pr-3">
                    <table>
                        <thead>
                            <tr>
                                <th>Nama / NIP</th>
                                <th>Jabatan</th>
                                <th>Email</th>
                                <th>Harga Satuan</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody v-if="tempPegawai.length != 0">
                            <tr v-for="(li, id) in tempPegawai" :key="id">
                                <td>
                                    <CRow>
                                        <CCol sm="12">
                                            {{li.nama}}
                                        </CCol>
                                        <CCol sm="12">
                                            <span style="font-size:12px;color:gray">{{li.nik}}</span>
                                        </CCol>
                                    </CRow>
                                </td>
                                <td>{{li.jabatan}}</td>
                                <td>{{li.email}}</td>
                                <td class="text-right">{{rupiahMode(li.hargaSatuan)}}</td>
                                <td>
                                    <CButton @click="deletePegawai(id)" type="button" class="btn btn-danger">Hapus</CButton>
                                </td>
                            </tr>
                            <tr v-if="tempPegawai.length != 0">
                                <td class="text-left font-weight-bold p-2" colspan="3">Total</td>
                                <td class="text-right font-weight-bold p-2" colspan="2">{{rupiahMode(totalHarga)}}</td>
                            </tr>
                        </tbody>
                        <tbody v-if="tempPegawai.length == 0">
                            <tr>
                                <td class="text-center p-4" colspan="5">Data tidak ditemukan, silahkan tambah pegawai.</td>
                            </tr>
                        </tbody>
                    </table>
                </CRow>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm('D')" v-if="unix != ''" type="button" class="btn btn-delete mr-2">Hapus</CButton>
                <CButton @click="submitForm('CU')" class="btn btn-edit-submit">Simpan</CButton>
            </CCol>
        </CRow>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { validationMixin } from 'vuelidate'

export default {
    props: ['isDetail', 'isData' , 'isStatus'],
    mixins: [validationMixin],
    validations: {
        namaPengadaan: {
            required,
        },
        nomorPengadaan: {
            required,
        },
        pjtk: {
            value: {
                required
            }
        },
        tanggalPengadaan: {
            required
        },
        qty: {
            required
        },
    },
    components: {
        ModelSelect
    },
    data() {
        return {
            flag2: '0',

            // data pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            idPegawai: '',

            loading: false,
            details: false,
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            datas: [],

            namaPengadaan: '',
            nomorPengadaan: '',
            qty: '',
            tempQty: '0',
            tanggalPengadaan: '',
            dataPJTK: [],
            pjtk: {
                value: '',
                text: '',
            },
            unix: '',
            // data unit
            dataUnit: [],
            titleUnit:"Pilih Bidang",
            selectedItemUnit: null,
            selectedUnit: 0,
            queryUnit: '',
            visibleUnit: false,
            idUnit: '',

            tempPegawai: [],
            tempBidang: [],
            totalHarga: '',
        }
    },
    methods: {
        moving() {
            this.details = false
            this.tempPegawai = []
            this.unix = ''
            this.$v.$reset()
            this.$emit('goDetail', false)
        },
        pharData() {
            let li = this.datas
            this.qty = li.qtyPengadaan
            var i = 0
            let data = this.dataPJTK
            for(i=0;i<data.length;i++) {
                if(li.idPerusahaanKontrak == data[i].value) {
                    this.pjtk.value = data[i].value
                    this.pjtk.text = data[i].text
                }
            }
            this.namaPengadaan = li.namaPengadaan
            this.nomorPengadaan = li.nomorPengadaan
            this.tanggalPengadaan = li.tanggalPengadaan
            this.tempBidang = li.listUnitLvl
            this.tempPegawai = li.listPegawai
            this.count()
            this.unix = li.idKontrakPengadaan
        },
        submitForm(val) {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                let tipe = ''
                if(val == 'CU') {
                    tipe = this.unix == '' ? 'C' : 'U'
                } else {
                    tipe = 'D'
                }
                this.goSave(tipe)
                this.loading = true
            }
        },
        goSave(val) {
            let list = this.tempPegawai
            let lvl = this.tempBidang
            let temp = []
            let unit = []
            var i, j = 0
            if(list.length != 0) {
                for(i=0;i<list.length;i++) {
                    temp.push(list[i].idPegawai)
                }
            }
            if(lvl.length != 0) {
                for(i=0;i<lvl.length;i++) {
                    unit.push(lvl[i].id)
                }
            }
            let payload = {
                idKontrakPengadaan: this.unix,
                idPerusahaanKontrak: this.pjtk.value,
                listPegawai: temp,
                namaPengadaan: this.namaPengadaan,
                nomorPengadaan: this.nomorPengadaan,
                qty: this.qty,
                tanggalPengadaan: this.tanggalPengadaan,
                type: val,
                unitLevel: unit
            }
            DataApi.post("kontrak_pengadaan/save", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.details = false
                this.$v.$reset()
                let sendParam = {
                    suc: this.success,
                    resp: this.alertMess
                }
                this.$emit('goUpdate', sendParam)
                this.loading = false
                this.currentAlertCounter = 7
            })
        },


        /**
         * SEARCH UNIT LEVEL
         */
        getDataUnit(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    limit: 10,
                    namaUnit: this.queryUnit,
                    pageIn: 1,
                    namaParentUnit: '',
                    idUnit: ''
                }
            } else {
                payload = {
                    limit: 10,
                    namaUnit: '',
                    pageIn: 1,
                    namaParentUnit: '',
                    idUnit: val
                }
            }
            DataApi.post("unit/get", payload)
            .then(res => {
                this.dataUnit = []
                let response = res.data.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = ''
                    if(tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang
                        }
                    } else {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang + ' - ' + tempData[i].parentBidang                            
                        }
                    }
                    this.dataUnit.push(onPush)
                }
                if(val != 'null') {
                    this.idUnit = val
                    this.queryUnit = this.dataUnit[0].text
                }
            })
        },
        toggleVisibleUnit() {
            this.visibleUnit = true;
        },
        hideUnit() {
            this.visibleUnit = false;
        },
        toggleCloseVisibleUnit() {
            setTimeout(this.hideUnit, 1000);
        },
        itemClickedUnit(index) {
            this.selectedUnit = index;
            this.selectItemUnit();
        },
        selectItemUnit() {
            if (!this.matchesUnit.length) {
            return;
            }
            this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
            
            let ol = this.tempBidang
            if(ol.length == 0) {
                let onPush = {
                    id: this.selectedItemUnit.value,
                    bidang: this.selectedItemUnit.text.split(" - ")[0]
                }
                this.tempBidang.push(onPush)
            } else {
                var i = 0
                let status = false
                for(i=0;i<ol.length;i++) {
                    if(ol[i].id == this.selectedItemUnit.value) {
                        status = true
                        break
                    } else {
                        status = false
                    }
                }
                if(status == false) {
                    let onPush = {
                        id: this.selectedItemUnit.value,
                        bidang: this.selectedItemUnit.text.split(" - ")[0]
                    }
                    this.tempBidang.push(onPush)
                }
            }
            this.queryUnit = ''
            this.idUnit = ''
            this.visibleUnit = false;
            if (this.shouldReset) {
            this.queryUnit = '';
            this.selectedUnit = 0;
            }
        },
        deleteUnit(val) {
            let del = this.tempBidang[val].id
            let pegawai = this.tempPegawai
            var i = 0
            let tampungan = []
            for(i=0;i<pegawai.length;i++) {
                if(del == pegawai[i].lvl) {
                    // nothing todo
                } else {
                    tampungan.push(pegawai[i])
                }
            }
            this.tempPegawai = tampungan
            this.tempBidang.splice(val,1)
        },
        upUnit() {
            if (this.selectedUnit == 0) {
            return;
            }
            this.selectedUnit -= 1;
            this.scrollToItemUnit();
        },
        downUnit() {
            if (this.selectedUnit >= this.matchesUnit.length - 1) {
            return;
            }
            this.selectedUnit += 1;
            this.scrollToItemUnit();
        },
        scrollToItemUnit() {
            this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
        },

        /**
         * SEARCH PJTK
         */
        getDataPJTK() {
            DataApi.post("perusahaan_kontrak/list")
            .then(res => {
                this.dataPJTK = []
                let response = res.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].id,
                        text: tempData[i].nama
                    }
                    this.dataPJTK.push(onPush)
                }
                if(this.isStatus == '1') {
                    this.datas = this.isData[0]
                    this.pharData()
                } else {
                    this.unix = ''
                }
            })
        },

        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let ol = this.tempBidang
            let lvl = []
            var i = 0
            for(i=0;i<ol.length;i++) {
                lvl.push(ol[i].id)
            }
            let payload = {
                lvl: lvl,
                organisasiPjtk: this.pjtk.value,
                nama: this.queryPegawai
            }
            DataApi.post("pegawai_kontrak/list_kontrak_pengadaan", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data.data
                var i = 0
                for(i=0;i<response.length;i++) {
                    let onPush = {
                        value: response[i].idPegawai,
                        text: response[i].nama + ' - ' + response[i].nik,
                        nik: response[i].nik,
                        jabatan: response[i].jabatan,
                        lvl: response[i].lvl,
                        email: response[i].email,
                        hargaSatuan: response[i].hargaSatuan,
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            if(this.tempPegawai.length < this.qty) {
                if(this.tempPegawai.length == 0) {
                    let onPush = {
                        idPegawai: this.selectedItemPegawai.value,
                        nama: this.selectedItemPegawai.text,
                        nik: this.selectedItemPegawai.nik,
                        jabatan: this.selectedItemPegawai.jabatan,
                        lvl: this.selectedItemPegawai.lvl,
                        email: this.selectedItemPegawai.email,
                        hargaSatuan: this.selectedItemPegawai.hargaSatuan
                    }
                    this.tempPegawai.push(onPush)
                } else {
                    let li = this.tempPegawai
                    let status = false
                    var i = 0
                    for(i=0;i<li.length;i++) {
                        if(li[i].idPegawai == this.selectedItemPegawai.value) {
                            status = true
                            break
                        } else {
                            status = false
                        }
                    }
                    if(status == false) {
                        let onPush = {
                            idPegawai: this.selectedItemPegawai.value,
                            nama: this.selectedItemPegawai.text,
                            nik: this.selectedItemPegawai.nik,
                            jabatan: this.selectedItemPegawai.jabatan,
                            lvl: this.selectedItemPegawai.lvl,
                            email: this.selectedItemPegawai.email,
                            hargaSatuan: this.selectedItemPegawai.hargaSatuan
                        }
                        this.tempPegawai.push(onPush)
                    }
                }
            } else {
                //
            }
            this.queryPegawai = ''
            this.idPegawai = ''
            this.count()
            this.visiblePegawai = false;
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },
        deletePegawai(val) {
            this.tempPegawai.splice(val,1)
            this.count()
        },
        count() {
            let val = this.tempPegawai
            let total = 0
            var i = 0
            for(i=0;i<val.length;i++) {
                total += parseInt(val[i].hargaSatuan)
            }
            this.totalHarga = total.toString()
        },
        rupiahMode(val) {
            var number_string = val.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            return hasil
        }
    },
    watch: {
        isDetail() {
            if(this.isDetail == true) {
                this.details = true
                this.$emit('goDetail', true)
            }
        },
        queryUnit() {
            if(this.queryUnit == '') {
                this.idUnit = ''
            }
            this.getDataUnit('null')
        },
        queryPegawai() {
            if(this.queryPegawai == '') {
                this.idPegawai = ''
            }
            this.getDataPegawai()
        },
        pjtk() {
            this.tempPegawai = []
        },
        tempBidang() {
            if(this.tempBidang.length == 0) {
                this.tempPegawai = []
            }
        },
        qty() {
            if(this.qty == '' || this.qty == 0) {
                // nothing todo
            } else {
                if(parseInt(this.qty) >= parseInt(this.tempQty)) {
                    this.tempQty = this.qty
                } else {
                    this.tempQty = this.qty
                    let temp = []
                    var i 
                    for(i=0;i<parseInt(this.qty);i++) {
                        temp.push(this.tempPegawai[i])
                    }
                    this.tempPegawai = temp
                    this.count()
                }
            }
        },
    },
    mounted() {
        this.getDataUnit("null")
        this.getDataPJTK()
        
        window.scroll({
            top:0,
            left: 0,
            behavior: 'smooth'
        });
    },
    computed: {
        matchesUnit() {
            if (this.queryUnit == '') {
                return [];
            }
            return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
        },
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
    }
}
</script>
<style scoped>
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}

.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}

.btn-delete {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid red;
    background-color:red;
    color: white;
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
input:disabled {
    opacity: 0.7;
}

table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 8px;
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 8px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 8px;
    padding-right: 8px;
}
td,th {
    /* overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap; */
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
</style>